import $http from '../../shared/http';

export const sms = {
  namespaced: true,
  state: () => {
    return {
      smsTemplates: null,
      smsTemplateData: null,
      smsTemplateUsageTypesForSelect: null,
      individualGroupAssigmentTemplateExistence: false,
      visitorWelcomeMessageTemplateExistence: false,
      birthdayMessageTemplateExistence: false,
      membershipIdReminderTemplateExistence: false,
      memberWelcomeMessageTemplateExistence: false,
      visitorHasBeenSentWelcomeMessage: false,
      smsAccount: null,
      smsTransactionData: null,
      monthlyRosterNotificationsExistence: false,
      smsRecipientTypesForSelect: null,
      smsTransactionTypesForSelect: null,
      smsMessageTypesForSelect: null,
      followUpMessageTemplateExistence: false,
    };
  },
  getters: {
    getSmsTemplates: (state) => state.smsTemplates,
    getSmsTemplateData: (state) => state.smsTemplateData,
    GET_SMS_TRANSACTION: (state) => state.smsTransactionData,
    getSmsTemplateUsageTypesForSelect: (state) => state.smsTemplateUsageTypesForSelect,
    GET_INDIVIDUAL_GROUP_ASSIGNMENT_TEMPLATE_EXISTENCE: (state) =>
      state.individualGroupAssigmentTemplateExistence,
    GET_VISITOR_WELCOME_MESSAGE_TEMPLATE_EXISTENCE: (state) =>
      state.visitorWelcomeMessageTemplateExistence,
    GET_BIRTHDAY_MESSAGE_TEMPLATE_EXISTENCE: (state) => state.birthdayMessageTemplateExistence,
    GET_SMS_ACCOUNT: (state) => state.smsAccount,
    GET_VISITOR_HAS_BEEN_SENT_WELCOME_MESSAGE: (state) => state.visitorHasBeenSentWelcomeMessage,
    GET_MEMBERSHIP_ID_REMINDER_TEMPLATE_EXISTENCE: (state) =>
      state.membershipIdReminderTemplateExistence,
    GET_MEMBER_WELCOME_MESSAGE_TEMPLATE_EXISTENCE: (state) =>
      state.memberWelcomeMessageTemplateExistence,
    GET_MONTHLY_ROSTER_NOTIFICATIONS_EXISTENCE: (state) =>
      state.monthlyRosterNotificationsExistence,
    GET_FOLLOW_UP_MESSAGE_TEMPLATE_EXISTENCE: (state) => state.followUpMessageTemplateExistence,
    GET_SMS_TRANSACTION_TYPES_FOR_SELECT: (state) => state.smsTransactionTypesForSelect,
    GET_SMS_MESSAGE_TYPES_FOR_SELECT: (state) => state.smsMessageTypesForSelect,
    GET_SMS_RECIPIENT_TYPES_FOR_SELECT: (state) => state.smsRecipientTypesForSelect,
  },
  mutations: {
    setSmsTemplates: (state, payload) => (state.smsTemplates = payload),
    setSmsTemplateData: (state, payload) => (state.smsTemplateData = payload),
    setSmsTransactionData: (state, payload) => (state.smsTransactionData = payload),
    setIndividualGroupAssigmentTemplateExistence: (state, payload) =>
      (state.individualGroupAssigmentTemplateExistence = payload),
    setVisitorWelcomeMessageTemplateExistence: (state, payload) =>
      (state.visitorWelcomeMessageTemplateExistence = payload),
    setBirthdayMessageTemplateExistence: (state, payload) =>
      (state.birthdayMessageTemplateExistence = payload),
    setMembershipIdReminderTemplateExistence: (state, payload) =>
      (state.membershipIdReminderTemplateExistence = payload),
    setMemberWelcomeMessageTemplateExistence: (state, payload) =>
      (state.memberWelcomeMessageTemplateExistence = payload),
    setFollowUpMessageTemplateExistence: (state, payload) =>
      (state.followUpMessageTemplateExistence = payload),
    setSmsTemplateUsageTypesForSelect: (state, payload) =>
      (state.smsTemplateUsageTypesForSelect = payload),
    setVisitorHasBeenSentWelcomeMessage: (state, payload) =>
      (state.visitorHasBeenSentWelcomeMessage = payload),
    setSmsAccount: (state, payload) => (state.smsAccount = payload),
    setMonthlyRosterNotificationsExistence: (state, payload) =>
      (state.monthlyRosterNotificationsExistence = payload),
    setSmsTransactionTypesForSelect: (state, payload) =>
      (state.smsTransactionTypesForSelect = payload),
    setSmsMessageTypesForSelect: (state, payload) => (state.smsMessageTypesForSelect = payload),
    setSmsRecipientTypesForSelect: (state, payload) => (state.smsRecipientTypesForSelect = payload),
  },
  actions: {
    async LOAD_SMS_TEMPLATES_ACTION({ commit }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get('/sms-templates')
          .then((response) => {
            commit('setSmsTemplates', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error?.response ?? error);
          });
      });
    },

    async LOAD_SMS_TEMPLATE_DATA({ commit }, ID) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/sms-templates/${ID}`)
          .then(async (response) => {
            commit('setSmsTemplateData', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error?.response ?? error);
          });
      });
    },

    async LOAD_SMS_TRANSACTION_DATA({ commit }, { id, churchId }) {
      return $http('v2')
        .get(`organisations/${churchId}/sms_transactions/${id}`)
        .then(async (response) => {
          commit('setSmsTransactionData', response.data.data);
          return response;
        })
        .catch((error) => {
          return Promise.reject(error?.response ?? error);
        });
    },

    async LOAD_SMS_TEMPLATE_USAGE_TYPES_FOR_SELECT({ commit }) {
      return $http('v2')
        .get(`sms_template_usage_types/select`, {})
        .then(async (response) => {
          commit('setSmsTemplateUsageTypesForSelect', response.data.data);
          return response;
        });
    },

    async CREATE_SMS_TEMPLATE(ctx, { form }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(`/sms-templates`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error?.response ?? error);
          });
      });
    },

    async SEND_ACTIVITY_NOTIFICATION_SMS(ctx, { service }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(`/sms/activity-assignment-notification/${service}`, undefined, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error?.response ?? error);
          });
      });
    },

    async SEND_INDIVIDUAL_SCHEDULE_SMS_NOTIFICATION(ctx, scheduleId) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(`/sms/individual-activity-assignment-notification/${scheduleId}`, undefined, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error?.response ?? error);
          });
      });
    },

    async SEND_GROUP_SCHEDULE_SMS_NOTIFICATION(ctx, { activityId, serviceId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(
            `/sms/group-activity-assignment-notification/${activityId}/${serviceId}`,
            undefined,
            { headers: { 'X-Is-Notifiable': 'On' } }
          )
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error?.response ?? error);
          });
      });
    },

    async SEND_VISITOR_WELCOME_MESSAGE_SMS(ctx, { ids, organisation_id }) {
      return $http('v2')
        .post(
          'sms_sending/visitor_welcome_messages',
          { ids, organisation_id },
          {
            headers: { 'X-Is-Notifiable': 'On' },
          }
        )
        .then(async (response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error?.response ?? error);
        });
    },

    async SEND_BIRTHDAY_MESSAGE_SMS(ctx, { members }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(
            `/sms/birthday-celebration-message`,
            { members },
            { headers: { 'X-Is-Notifiable': 'On' } }
          )
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error?.response ?? error);
          });
      });
    },

    async SEND_MEMBERSHIP_ID_REMINDER_SMS(ctx, { ids, organisation_id }) {
      return $http('v2')
        .post(
          `sms_sending/membership_id_reminders`,
          { ids, organisation_id },
          {
            headers: { 'X-Is-Notifiable': 'On' },
          }
        )
        .then(async (response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error?.response ?? error);
        });
    },

    async SEND_MEMBER_WELCOME_MESSAGE(ctx, { ids, organisation_id }) {
      return $http('v2')
        .post(
          `sms_sending/member_welcome_messages`,
          { ids, organisation_id },
          {
            headers: { 'X-Is-Notifiable': 'On' },
          }
        )
        .then(async (response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error?.response ?? error);
        });
    },

    async EDIT_SMS_TEMPLATE(ctx, { form, ID }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .patch(`/sms-templates/${ID}`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error?.response ?? error);
          });
      });
    },

    async DELETE_SMS_TEMPLATE(ctx, { id }) {
      return $http()
        .delete(`/sms-templates/${id}`, { notifiable: true })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async CHECK_INDIVIDUAL_GROUP_ASSIGNMENT_TEMPLATE_EXISTENCE({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/organisations/${churchId}/sms-templates/individual-group-template-existence`, {
            canBeImpersonated: true,
          })
          .then(async (response) => {
            commit('setIndividualGroupAssigmentTemplateExistence', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            commit('setIndividualGroupAssigmentTemplateExistence', false);
            reject(error?.response ?? error);
          });
      });
    },

    async CHECK_VISITOR_WELCOME_MESSAGE_TEMPLATE_EXISTENCE({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(
            `/organisations/${churchId}/sms-templates/visitor-welcome-message-template-existence`,
            { canBeImpersonated: true, notifiable: true }
          )
          .then(async (response) => {
            commit('setVisitorWelcomeMessageTemplateExistence', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            commit('setVisitorWelcomeMessageTemplateExistence', false);
            reject(error?.response ?? error);
          });
      });
    },

    async CHECK_BIRTHDAY_MESSAGE_TEMPLATE_EXISTENCE({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/organisations/${churchId}/sms-templates/birthday-message-template-existence`, {
            canBeImpersonated: true,
            notifiable: true,
          })
          .then(async (response) => {
            commit('setBirthdayMessageTemplateExistence', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            commit('setBirthdayMessageTemplateExistence', false);
            reject(error?.response ?? error);
          });
      });
    },

    async CHECK_MEMBERSHIP_ID_REMINDER_TEMPLATE_EXISTENCE({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(
            `/organisations/${churchId}/sms-templates/membership-id-reminder-template-existence`,
            { canBeImpersonated: true, notifiable: true }
          )
          .then(async (response) => {
            commit('setMembershipIdReminderTemplateExistence', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            commit('setMembershipIdReminderTemplateExistence', false);
            reject(error?.response ?? error);
          });
      });
    },

    async CHECK_MEMBER_WELCOME_MESSAGE_TEMPLATE_EXISTENCE({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(
            `/organisations/${churchId}/sms-templates/member-welcome-message-template-existence`,
            { canBeImpersonated: true, notifiable: true }
          )
          .then(async (response) => {
            commit('setMemberWelcomeMessageTemplateExistence', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            commit('setMemberWelcomeMessageTemplateExistence', false);
            reject(error?.response ?? error);
          });
      });
    },

    async CHECK_FOLLOW_UP_MESSAGE_TEMPLATE_EXISTENCE({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/organisations/${churchId}/sms-templates/follow-up-message-template-existence`, {
            canBeImpersonated: true,
          })
          .then(async (response) => {
            commit('setFollowUpMessageTemplateExistence', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            commit('setFollowUpMessageTemplateExistence', false);
            reject(error?.response ?? error);
          });
      });
    },

    async CREATE_SMS_ACCOUNT({ commit }, { churchId }) {
      return $http('v2')
        .post(`organisations/${churchId}/sms_account`, undefined, { notifiable: true })
        .then(async (response) => {
          commit('setSmsAccount', response.data.data);
          return response.data.message; // Send message to component for alert
        });
    },

    async LOAD_SMS_ACCOUNT({ commit }, { churchId }) {
      return $http('v2')
        .get(`/organisations/${churchId}/sms_account`, { canBeImpersonated: true })
        .then(async (response) => {
          commit('setSmsAccount', response.data.data);
          return response;
        })
        .catch((error) => {
          return Promise.reject(error?.response ?? error);
        });
    },

    async SEND_BULK_SMS(ctx, { type, ids, text, organisation_id }) {
      return $http('v2')
        .post(
          `sms_sending/bulk_sms/${type}`,
          { text, ids, organisation_id },
          { headers: { 'X-Is-Notifiable': 'On' } }
        )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async SEND_MONTHLY_ROSTER_NOTIFICATIONS(ctx, currentMonthYear) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post('/sms/rosters/monthly-roster-notifications', currentMonthYear, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async CHECK_MONTHLY_ROSTER_NOTIFICATIONS({ commit }, { month, year, churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/organisations/${churchId}/roster-notifications/${month}/${year}`, {
            canBeImpersonated: true,
          })
          .then(async (response) => {
            commit('setMonthlyRosterNotificationsExistence', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            commit('setMonthlyRosterNotificationsExistence', false);
            reject(error?.response ?? error);
          });
      });
    },

    async LOAD_SMS_RECIPIENT_TYPES_FOR_SELECT({ commit }) {
      return $http('v2')
        .get(`/sms_recipient_types/select`)
        .then((response) => {
          commit('setSmsRecipientTypesForSelect', response.data.data);
          return response;
        });
    },

    async LOAD_SMS_MESSAGE_TYPES_FOR_SELECT({ commit }) {
      return $http('v2')
        .get(`sms_message_types/select`)
        .then((response) => {
          commit('setSmsMessageTypesForSelect', response.data.data);
          return response;
        });
    },

    async LOAD_SMS_TRANSACTION_TYPES_FOR_SELECT({ commit }) {
      return $http('v2')
        .get(`/sms_transaction_types/select`)
        .then((response) => {
          commit('setSmsTransactionTypesForSelect', response.data.data);
          return response;
        });
    },
  },
};
